import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  modality: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    listStyle: 'none',
    margin: '0px',
    padding: '5px 15px 5px 5px',
    borderBottom: '1px solid rgba(149, 149, 149, 0.4)',
  },
}));

export default useStyles;
